module.exports = __webpack_public_path__ + "img/book1.4d6d6b7c.jpg";